import useOpenDropdownOnResults from './useOpenDropdownOnResults'

export default useOpenDropdownOnResults
